module.exports = __webpack_public_path__ + "static/img/erWeiMa.6c8d476.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footerNav/erWeiMa.png
// module id = XmSb
// module chunks = 31